import React from 'react'
import PropTypes from 'prop-types'
import { withTranslationCustom } from 'lib/i18next'
import { isMobile } from 'react-device-detect'
import { isProductionHost } from 'lib/env'

import EventAttachmentsList from './EventAttachmentsList/EventAttachmentsList'
import AddAttachmentButton from 'components/Attachments/AddAttachmentButton'
import Icon from 'components/Icon'

import './event-attachments.pcss'

const EventAttachments = ({ attachments, onRemove, loading, t }) => (
    <div className="event-attachments">
        <EventAttachmentsList
            attachments={attachments}
            onRemove={onRemove}
            displayLoadingItem={loading}
        />
        {(!attachments.length && !loading) && (
            <p className="event-attachments__description">
                {t('events:eventAttachment')}
            </p>
        )}
        <div className="event-attachments__actions">
            {(isMobile || !isProductionHost()) && (
                <AddAttachmentButton
                    className="button button--tertiary"
                    cameraMode
                >
                    <Icon fa name="camera" cssClass="icon--event-form" />
                    {t('common:takeNewPicture')}
                </AddAttachmentButton>
            )}
            <AddAttachmentButton
                className="button button--tertiary"
            >
                <Icon fa name="image" cssClass="icon--event-form" />
                {t('common:addImageOrFile')}
            </AddAttachmentButton>
        </div>
    </div>
)

EventAttachments.propTypes = {
    attachments: PropTypes.array.isRequired,
    onRemove: PropTypes.func.isRequired,
    loading: PropTypes.bool,
}

export default withTranslationCustom(['common', 'events'])(EventAttachments)
